// src/components/HeroSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; // 1. Import motion

const HeroSection = () => {
    
    // 2. Define animation variants for staggered children
    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                delayChildren: 0.3, // Delay before animating children
                staggerChildren: 0.2, // Stagger children animations by 0.2s
                duration: 0.6
            }
        }
    };

    // 3. Define animation variants for individual items
    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: { y: 0, opacity: 1 }
    };
    
    return (
        <div className="hero-section">
            <motion.div 
                className="hero-container"
                // 4. Apply Framer Motion properties to the main container
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {/* 5. Apply item variants to elements inside the container */}
                <motion.h1 className="hero-title" variants={itemVariants}>
                    The Online Community for New Yorkers. Stay Connected to Your City.
                </motion.h1>
                
                <motion.p className="hero-subtitle" variants={itemVariants}>
                    Local conversations, real-time updates, and neighborhood discussions across all boroughs.
                </motion.p>
                
                {/* 6. Apply item variants to the button group */}
                <motion.div className="hero-button-group" variants={itemVariants}>
                    
                    <Link to="/signup" className="hero-button hero-primary-button">
                        Join the Community
                    </Link>
                    
                    <Link to="/topics" className="hero-button hero-secondary-button">
                        Explore Chat Rooms
                    </Link>
                    
                </motion.div>
            </motion.div>
        </div>
    );
};

export default HeroSection;